<template>
  <div class="statistics-group-table">
    <CmStatTable
      :chunkSize="1000"
      :shortChunkSize="1000"
      :isLongTable="true"
      :value="value"
      :cols="cols"
      @open-long-table="setLongTablePart(longTableId)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import long_table_mixin from "@/components/statistics/stats/tabs/long_table_mixin";
import CmStatTable from "@/components/library/statistics/elements/CmStatTable.vue";

export default {
  name: "GroupTable",

  components: {
    CmStatTable,
  },

  mixins: [long_table_mixin],

  props: {
    longTableId: {
      type: String,
    },
    cols: {
      type: Object,
    },
    formData: {
      type: Function,
    },
  },

  computed: {
    ...mapGetters({
      groupByDetails: "getDetails",
    }),

    value() {
      return this.formData(this.groupByDetails);
    },
  },
};
</script>

<style lang="scss" scoped>
.section-statistics__tab {
  width: 100%;
}

.statistics-group-table {
  &__groupby-select {
    display: flex;
    align-items: center;
    line-height: 100%;
    justify-content: flex-end;
    margin-bottom: 20px;

    .cm-select {
      margin-left: 15px;
    }
  }

  .cm-stat-table {
    width: 100% !important;

    tr {
      outline: 0;
      td,
      th {
        text-align: center;
        padding: 0 9px;
        outline: 0;
      }

      .bold {
        text-align: left;
        font-weight: normal;
        white-space: normal;
      }
    }

    tbody {
      tr {
        cursor: pointer;

        &:hover {
          background: rgba($color_primary, 0.15) !important;
        }
      }
    }
  }

  ::v-deep .cm-stat-table-container {
    .cm-stat-table__footer {
      display: none;
    }
  }
}
</style>
